/*
 * Site footer (sections/jc-site-footer.liquid).
 * - Back to top: scrolls up (smooth unless reduced motion), then moves focus to the top of the page.
 * - After a newsletter post the page reloads at the form; the message gets focus so it is read.
 */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (e) => {
    const top = e.target.closest && e.target.closest('[data-jcf-top]');
    if (top) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduce() ? 'auto' : 'smooth' });
      const target = document.querySelector('.skip-to-content-link') || document.querySelector('a[href], button');
      if (target) target.focus({ preventScroll: true });
    }
  });

  const msg = document.querySelector('.jcf-news__msg');
  if (msg) {
    msg.scrollIntoView({ block: 'center' });
    msg.focus({ preventScroll: true });
  }
})();
